import { useEffect, useState } from 'react';

const AUTH_UPDATED_EVENT_NAME = 'auth_updated_event';

const AUTH_LOCAL_STORAGE_KEYS = [
  'accessToken',
  'employeeKey',
  'deviceKey',
  'impersonatedCompanyKeys',
  'impersonatedRole',
] as const;

class AuthUpdatedEvent extends CustomEvent<void> {
  constructor() {
    super(AUTH_UPDATED_EVENT_NAME);
  }
}

export function getAuth() {
  return {
    accessToken: localStorage.getItem('accessToken'),
    employeeKey: localStorage.getItem('employeeKey'),
    deviceKey: localStorage.getItem('deviceKey'),
    impersonatedCompanyKeys: localStorage.getItem('impersonatedCompanyKeys'),
    impersonatedRole: localStorage.getItem('impersonatedRole'),
  };
}

export function updateAuth(authData: {
  accessToken?: string | null;
  employeeKey?: string | null;
  deviceKey?: string | null;
  impersonatedCompanyKeys?: string | null;
  impersonatedRole?: string | null;
}) {
  for (const key of AUTH_LOCAL_STORAGE_KEYS) {
    const value = authData[key];

    if (value !== undefined) {
      if (value === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, value);
      }
    }
  }

  document.dispatchEvent(new AuthUpdatedEvent());
}

export function removeAuth() {
  for (const key of AUTH_LOCAL_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }

  document.dispatchEvent(new AuthUpdatedEvent());
}

function addUpdateAuthEventListener(listener: () => void) {
  document.addEventListener(AUTH_UPDATED_EVENT_NAME, listener);
}

function removeUpdateAuthEventListener(listener: () => void) {
  document.removeEventListener(AUTH_UPDATED_EVENT_NAME, listener);
}

export function useAuth() {
  const [auth, setAuth] = useState(getAuth);

  useEffect(() => {
    const listener = () => setAuth(getAuth());
    addUpdateAuthEventListener(listener);
    return () => removeUpdateAuthEventListener(listener);
  }, []);

  return auth;
}
